import React, { Component } from "react";
import "./loader.css";

export const Loader = () => {
  return (
    <div id="loader" className="loader-container">
      <div className="spinner spinner3"></div>
    </div>
  );
};
